import { Nullable } from 'global';
import { logError } from 'utils/logger';
import { useMutation } from '@apollo/client';
import { useNotifications } from 'modules/notification';
import { aftermarketProductsApi } from '../api';
import {
  CreateDTO,
  UpdateDTO,
  CreateProductResponse,
  CreateProductVariables,
  UpdateProductResponse,
  UpdateProductVariables,
} from '../api/types';

export function useAftermarketProducts() {
  const { showNotification } = useNotifications();

  const [onCreate, { loading: isCreating }] = useMutation<CreateProductResponse, CreateProductVariables>(
    aftermarketProductsApi.createProduct
  );

  const [onUpdate, { loading: isUpdating }] = useMutation<UpdateProductResponse, UpdateProductVariables>(
    aftermarketProductsApi.updateProduct
  );

  const handleAftermarketProductCreate = async (DTO: CreateDTO): Promise<Nullable<string>> => {
    try {
      const { data: createResponse } = await onCreate({ variables: { input: DTO } });

      showNotification('Aftermarket product created successfully!');

      return createResponse?.create?.aftermarketProductId ?? null;
    } catch (error) {
      logError(error);
      showNotification('An error occurred', { type: 'error' });
      return null;
    }
  };

  const handleAftermarketProductUpdate = async (DTO: UpdateDTO): Promise<Nullable<string>> => {
    try {
      const { data: updateResponse } = await onUpdate({ variables: { input: DTO } });

      showNotification('Aftermarket product updated successfully!');

      return updateResponse?.update?.aftermarketProductId ?? null;
    } catch (error) {
      logError(error);
      showNotification('An error occurred', { type: 'error' });
      return null;
    }
  };

  return {
    isCreating,
    isUpdating,
    handleAftermarketProductCreate,
    handleAftermarketProductUpdate,
  };
}
